<template>
    <div>
        <div id="overlay"  v-if="loading">
        <div class="spinner"></div>
        <br/>
          <h4>Loading...</h4>
        </div>
            <form class="form-horizontal">
              <div class="p-grid">
                <div class="p-col">
                  <!-- <Button class="p-button-raised p-button-rounded" style="float:right;" @click.prevent="openBasic" icon="pi pi-plus"/> -->
                  <Button class="p-button p-component p-button-success addNewBtn"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
                </div>
              </div>
              <Dialog header="Transportation Details" :visible.sync="displayBasic"
               :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
               <div class="p-fluid p-formgrid p-grid">
                 <div class="p-field p-col-12 p-md-4">
                  <label for="subHead">Name<span style="color:red">*</span></label>
                  <InputText v-model.trim="name"  id="subHead"/>
                </div>
                <!-- <div class="p-field p-col-12 p-md-6"></div> -->
                  <div class="p-field p-col-12 p-md-4">
                    <label for="costing">Route</label>
                    <!-- <div class="p-field p-col-12 p-md-6"> -->
                    <InputText v-model.trim="route"  id="subHead"/>
                    <!-- </div> -->
                </div>

                <div class="p-field p-col-12 p-md-4">
                    <label for="costing">Address</label>
                    <!-- <div class="p-field p-col-12 p-md-6"> -->
                    <InputText v-model.trim="address"  id="subHead"/>
                    <!-- </div> -->
                </div>
                 <div class="p-field p-col-12 p-md-4">
                   <label for="vat">Contact Name</label>
                   <!-- <div class="p-field p-col-12 p-md-6"> -->
                    <InputText v-model.trim="contactPerson"  id="subHead"/>
                  <!-- </div> -->
                 </div>
                 <div class="p-field p-col-12 p-md-4">
                   <label for="head">From Contact Number <span style="color:red">*</span></label>
                   <InputText v-model.trim="contactNumberFrom"  id="subHead"/>
                 </div>
    
                 <div class="p-field p-col-12 p-md-4">
                   <label for="head">Branch - To Contact Number</label>
                   <!-- <InputText v-model.trim="contactNumberTo"  id="subHead"/> -->
                   <textarea type="text" rows="2" class="form-control" v-model="contactNumberTo"/>
                   <!-- <Dropdown
                      v-model="creditAccountId"
                      :options="accountMasterList"
                      optionLabel="name" :filter="true"
                      placeholder="Select Credit Account"
                      :showClear="true"
                    /> -->
                 </div>
              </div>
            <template #footer >
                <Button class="p-button-raised" v-if="!view" @click.prevent="addTransportationDetails" :label="!editing?'Add':'Update'"/>
                <Button class="p-button-raised p-button-info" @click.prevent="addAndNewExtraExpenses" v-if="!editing && !view"
                 label="Add & New"/>
              <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </template>
          </Dialog>
        </form>
      </div>
    </template>
    <script>
    import Checkbox from 'primevue/checkbox'
    import Dropdown from 'primevue/dropdown'
    import Dialog from 'primevue/dialog'
    import Button from 'primevue/button'
    import InputText from 'primevue/inputtext'
    import Textarea from 'primevue/textarea'
    export default {
      name: 'measurementUnit',
      data() {
        return {
          costing: false,
          vat: false,
          extreExpenses: {},
          creditAccountId: null,
          debitAccountId: null,
          editing: false,
          view: false,
          displayBasic: false,
          contactNumberFrom: '',
          contactNumberTo: '',
          contactPerson: '',
          address: '',
          route: '',
          name: '',
          id: '',
          loading: false
        }
      },
      computed: {
        // transportationDetailsList() {
        //   return this.$store.state.accountMaster.transportationDetailsDetails
        // }
      },
      mounted() {
        // this.transportationDetailsList()
      },
      methods: {
        async addTransportationDetails() {
          if (this.name === '') {
            this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
            return
          }
          if (this.address === '' || this.address === null) {
            this.$toast.add({severity: 'error', summary: '', detail: 'Address cannot be empty!', life: 10000})
            return
          }
          let response = ''
        //   if (this.creditAccountId === null) {
        //     this.creditAccountId = 0
        //   }
          let transportation = {
            id: this.id,
            contactNumberFrom: this.contactNumberFrom,
            contactNumberTo: this.contactNumberTo,
            contactPerson: this.contactPerson,
            address: this.address,
            route: this.route,
            name: this.name
          }
          if (!this.editing) {
            this.loading = !this.loading
            response = await this.$store.dispatch('createTransportation', transportation)
            this.loading = false
          } else {
            this.loading = !this.loading
            response = await this.$store.dispatch('updateTransportationDetails', transportation)
            this.loading = false
          }
          this.responseMessage(response)
          this.closeBasic()
        },
        async addAndNewExtraExpenses() {
          if (this.name === '') {
            this.$toast.add({severity: 'error', summary: '', detail: 'Extra expenses name cannot be empty!', life: 10000})
            return
          }
          if (this.address === '' || this.address === null) {
            this.$toast.add({severity: 'error', summary: '', detail: 'Address cannot be empty!', life: 10000})
            return
          }
          let response = ''
          let transportation = {
            contactNumberFrom: this.contactNumberFrom,
            contactNumberTo: this.contactNumberTo,
            contactPerson: this.contactPerson,
            address: this.address,
            route: this.route,
            name: this.name,
            id: this.id
          }
          this.loading = !this.loading
          response = await this.$store.dispatch('createTransportation', transportation)
          this.loading = false
          this.responseMessage(response)
        },
        async transportationDetailsList() {
          await this.$store.dispatch('loadTransportationDetailsList')
        },
        cancel() {
          this.show = false
          this.reset()
          this.closeBasic()
        },
        responseMessage(response) {
          if (response.data.status === 'SUCCESS') {
            this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
            this.reset()
          } else {
            this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
          }
        },
        editTransportation(data) {
          this.contactNumberFrom = data.contactNumberFrom
          this.contactNumberTo = data.contactNumberTo
          this.contactPerson = data.contactPerson
          this.address = data.address
          this.route = data.route
          this.name = data.name
          this.id = data.id
          this.openBasic()
          this.editing = true
        },
        viewTransportation(data) {
          this.contactNumberFrom = data.contactNumberFrom
          this.contactNumberTo = data.contactNumberTo
          this.contactPerson = data.contactPerson
          this.address = data.address
          this.route = data.route
          this.name = data.name
          this.id = data.id
          this.openBasic()
          this.editing = false
          this.view = true
        },
        reset() {
          this.name = ''
          this.editing = false
          this.contactNumberFrom = ''
          this.contactNumberTo = ''
          this.contactPerson = ''
          this.address = ''
          this.route = ''
          this.view = false
        },
        openBasic() {
          this.displayBasic = true
        },
        closeBasic() {
          this.displayBasic = false
        }
      },
      components: {
        Checkbox,
        Dropdown,
        Dialog,
        Button,
        InputText,
        Textarea
      }
    }
    </script>
    <style scoped src="@../../../static/css/dialogEntry.css">
    </style>



// WEBPACK FOOTER //
// transportationDetailsDialog.vue?5c19a496